<template>
  <b-modal id="tutoria" hide-header hide-footer centered>
    <h4 class="purple">Tutorandos</h4>
    <div class="wrap-competence">
      <div class="container-fluid" style="margin: 0">
        <b-row class="box-content">
          <b-col cols="12" md="12" class="col">
            <div class="col-content">
              <div class="students-list">
                <div class="about">
                  <h5>Atribuir novos tutorandos</h5>
                </div>
                <form>
                  <fieldset>
                    <input
                      type="text"
                      v-model="searchStudentAvailable"
                      placeholder="Buscar por nome..."
                      class="input-search"
                    />
                  </fieldset>
                </form>
                <div class="box-select-all">
                  <select
                    v-model="selectedCycle"
                    v-on:change="getFilteredByCycle"
                  >
                    <option value="" selected>Todos ciclos</option>
                    <option
                      v-for="cycle in cycles"
                      :key="cycle.id"
                      :value="cycle.id"
                    >
                      {{ cycle.name }}
                    </option>
                  </select>

                  <button
                    v-if="filteredAvailableStudents.length > 0"
                    @click="addAllFilteredStudents"
                    class="btn-add-all-topics"
                  >
                    Adicionar Todos ({{ filteredAvailableStudents.length }})
                  </button>
                </div>

                <ul v-if="filteredAvailableStudents.length > 0">
                  <li
                    v-for="student in filteredAvailableStudents"
                    :key="student.id"
                    @click="selectStudent(student)"
                    :class="
                      student.name.includes('Possui tutor!')
                        ? 'blocked-student'
                        : 'clickable-student'
                    "
                  >
                    <div>
                      <p class="name">{{ student.name }}</p>
                    </div>
                    <div
                      :class="
                        student.name.includes('Possui tutor!')
                          ? 'blocked-icon'
                          : 'add-icon'
                      "
                    >
                      <span v-if="student.name.includes('Possui tutor!')"
                        >🔒</span
                      >
                      <span v-else>+</span>
                    </div>
                  </li>
                </ul>
                <div v-else class="empty-student-list">
                  <p>
                    {{
                      searchStudentAvailable
                        ? "Nenhum aluno encontrado"
                        : "Nenhum aluno disponível"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="12" class="col">
            <div class="col-content list">
              <div class="students-list">
                <div class="about">
                  <h5>
                    Alunos Adicionados
                    <span
                      v-if="studentsAssigneds.length > 0"
                      class="badge-count"
                    >
                      ({{ studentsAssigneds.length }})
                    </span>
                  </h5>
                </div>
                <button
                  v-if="studentsAssigneds.length > 0"
                  @click="removeAllNewStudents"
                  class="btn-remove-all-topics-small mb-3"
                >
                  Remover Todos
                </button>
                <ul v-if="studentsAssigneds.length > 0">
                  <li
                    v-for="(student, index) in studentsAssigneds"
                    :key="student.id"
                  >
                    <div>
                      <p class="name">{{ student.name }}</p>
                    </div>
                    <div class="remove-item">
                      <span @click="deleteStudent(index)">
                        <DeleteIcon />
                      </span>
                    </div>
                  </li>
                </ul>
                <div v-else class="empty-student-list">
                  <p>Nenhum aluno atribuído</p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Alunos Tutorandos Atualmente -->
    <div class="wrap-competence align-items-center">
      <div class="container-fluid student-container">
        <div class="about">
          <h5 class="title-current-students">
            Alunos Tutorandos
            <span
              v-if="currentStudentsAssigneds.length > 0"
              class="badge-count"
            >
              ({{ currentStudentsAssigneds.length }})
            </span>
          </h5>
        </div>
        <button
          v-if="currentStudentsAssigneds.length > 0"
          @click="deleteAllStudentsFromTutoring"
          class="btn-remove-all-topics"
        >
          Remover Todos
        </button>
        <b-row class="mt-3">
          <b-col cols="12">
            <div class="students-list">
              <ul v-if="currentStudentsAssigneds.length > 0">
                <li
                  v-for="student in currentStudentsAssigneds"
                  :key="student.id"
                  class="current-student"
                >
                  <div>
                    <p class="name">{{ student.name }}</p>
                  </div>
                  <div class="remove-item">
                    <span
                      @click.prevent="deleteStudentFromTutoring(student.id)"
                    >
                      <DeleteIcon />
                    </span>
                  </div>
                </li>
              </ul>
              <div v-else class="empty-student-list">
                <p>Nenhum tutorando atualmente</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <b-row class="mt-5">
      <b-col md="6">
        <b-button @click="closeModal" class="large blue outline">
          Voltar
        </b-button>
      </b-col>
      <b-col md="6" class="text-right">
        <b-button
          @click="saveTutoringAssignments"
          class="large blue"
          :disabled="studentsAssigneds.length === 0 || !teacherId"
        >
          Salvar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

import DeleteIcon from "@/components/svg/DeleteIcon";
import httpRda from "../../http-rda";

export default {
  name: "TutoriaModal",
  components: {
    DeleteIcon,
  },

  props: {
    teacherId: {
      type: String,
      required: true,
    },
    teacherCycles: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      searchStudentAvailable: "",
      students: [],
      studentsAvailable: [],
      studentsAssigneds: [],
      currentStudentsAssigneds: [],
      cycles: [],
      selectedCycle: "",
    };
  },

  computed: {
    filteredAvailableStudents() {
      let list = this.studentsAvailable;

      if (this.selectedCycle && this.selectedCycle !== "") {
        list = list.filter(
          (student) => student.cicle_id === this.selectedCycle
        );
      }

      if (this.searchStudentAvailable) {
        const searchTerm = this.searchStudentAvailable
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        list = list.filter((student) => {
          const name = student.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return name.includes(searchTerm);
        });
      }

      return list;
    },
  },

  watch: {
    teacherCycles: {
      immediate: true,
      handler(newCycles) {
        if (newCycles && newCycles.length > 0) {
          this.getTeacherCycles();
          this.getStudents();
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions({
      getStudents: "community/listStudents",
    }),

    getFilteredByCycle(list) {
      if (!this.selectedCycle || this.selectedCycle === "") {
        return list;
      }
      return list.filter((student) => student.cicle_id === this.selectedCycle);
    },

    cycleFilter() {
      if (!this.selectedCycle) {
        return this.studentsAvailable;
      }

      if (this.selectedCycle === "") {
        return this.studentsAvailable;
      }

      return (this.studentsAvailable = this.studentsAvailable.filter(
        (student) => {
          return student.cicle_id === this.selectedCycle;
        }
      ));
    },

    getTeacherCycles() {
      this.cycles = this.teacherCycles.map((cycle) => ({
        id: cycle.id,
        name: cycle.name || cycle.designation,
      }));
      return this.teacherCycles.map((cycle) => cycle.id);
    },

    async getStudents() {
      const teacherCycles = await this.getTeacherCycles();

      await httpRda
        .get(
          `studentsforconcierge?teacherId=${
            this.teacherId
          }&cycles=${teacherCycles.join(",")}`
        )
        .then((res) => {
          let students = res.data.students;
          students = students.map((item) => {
            item.User.student_id = item.id;
            return {
              ...item.User,
              cicle_id: item.cycle_id,
            };
          });

          this.students = students;
        })
        .catch(() => {});

      const tutoredStudents = await httpRda
        .get(`/tutoringAllStudents`)
        .then((res) => res.data.response);

      this.students = this.students
        .map((e) => {
          if (tutoredStudents.includes(e.student_id)) {
            e.name = `${e.name} => Possui tutor!`;
            return e;
          }
          return e;
        })
        .filter((e) => e !== undefined);

      this.updateAvailableStudents();
    },

    updateAvailableStudents() {
      const assignedIds = this.studentsAssigneds.map((s) => s.id);
      const currentIds = this.currentStudentsAssigneds.map((s) => s.id);
      const allAssignedIds = [...assignedIds, ...currentIds];

      this.studentsAvailable = this.students
        .filter((student) => !allAssignedIds.includes(student.id))
        .sort((a, b) => {
          const aHasTutor = a.name.includes("Possui tutor!");
          const bHasTutor = b.name.includes("Possui tutor!");

          if (aHasTutor && !bHasTutor) return 1;
          if (!aHasTutor && bHasTutor) return -1;

          return a.name.localeCompare(b.name);
        });
    },

    async getAssignedStudents() {
      let response = await httpRda
        .get(`/tutoring/${this.teacherId}`)
        .then((res) => res.data);

      this.currentStudentsAssigneds = response.tutoring.students
        .map((e) => {
          return { id: e.Student.id, name: e.Student.User.name };
        })
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

      this.updateAvailableStudents();
    },

    selectStudent(student) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (student.name.includes("Possui tutor!")) {
        Toast.fire({
          icon: "error",
          title:
            "Não é possível atribuir esse aluno!\nJá é tutorando de outro professor!",
        });
        return;
      }

      if (!student || !student.id) return;

      if (this.studentsAssigneds.some((sa) => sa.id === student.id)) {
        Toast.fire({
          icon: "error",
          title: "Aluno já atribuído!",
        });
        return;
      }

      this.studentsAssigneds.push(student);
      this.studentsAssigneds.sort((a, b) => a.name.localeCompare(b.name));
      this.updateAvailableStudents();
    },

    addAllFilteredStudents() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

      const studentsWithTutor = this.filteredAvailableStudents.filter((s) =>
        s.name.includes("Possui tutor!")
      );

      if (studentsWithTutor.length > 0) {
        Toast.fire({
          icon: "warning",
          title: `${studentsWithTutor.length} aluno(s) não foram adicionados pois já possuem tutor!`,
        });
      }

      const validStudents = this.filteredAvailableStudents.filter(
        (s) => !s.name.includes("Possui tutor!")
      );

      validStudents.forEach((student) => {
        if (!this.studentsAssigneds.some((sa) => sa.id === student.id)) {
          this.studentsAssigneds.push(student);
        }
      });

      this.studentsAssigneds.sort((a, b) => a.name.localeCompare(b.name));
      this.updateAvailableStudents();
      this.searchStudentAvailable = "";

      if (validStudents.length > 0) {
        Toast.fire({
          icon: "success",
          title: `${validStudents.length} aluno(s) adicionado(s)!`,
        });
      }
    },

    removeAllNewStudents() {
      this.studentsAssigneds = [];
      this.updateAvailableStudents();
    },

    deleteStudent(index) {
      const newStudentList = [...this.studentsAssigneds];
      newStudentList.splice(index, 1);
      this.studentsAssigneds = newStudentList;
      this.updateAvailableStudents();
    },

    async deleteStudentFromTutoring(student_id) {
      this.$swal
        .fire({
          title: "Tem certeza que deseja remover o estudante dessa tutoria?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await httpRda.delete(`/tutoring/${student_id}`);
              this.$swal
                .fire("Excluído!", "Aluno excluído da tutoria.", "success")
                .then(() => {
                  this.getAssignedStudents();
                });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel excluir!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch(() => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel excluir!",
            footer: "Por favor, tente novamente mais tarde.",
          });
        });
    },

    async deleteAllStudentsFromTutoring() {
      this.$swal
        .fire({
          title:
            "Tem certeza que deseja remover TODOS os tutorandos(as) desse tutor(a)?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir todos!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await httpRda.delete(
                `/tutoring/${this.teacherId}/removeAllStudents`
              );

              this.$swal
                .fire(
                  "Excluído!",
                  "Todos os alunos foram excluídos da tutoria.",
                  "success"
                )
                .then(() => {
                  this.getAssignedStudents();
                });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possível excluir todos os alunos!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch(() => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possível excluir!",
            footer: "Por favor, tente novamente mais tarde.",
          });
        });
    },

    async saveTutoringAssignments() {
      if (!this.teacherId || this.studentsAssigneds.length === 0) {
        return;
      }

      const students_id = this.studentsAssigneds.map(
        (student) => student.student_id
      );

      try {
        await httpRda.post(`tutoring`, {
          students_id: students_id,
          teacher_id: this.teacherId,
        });

        const Toast = this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        Toast.fire({
          icon: "success",
          title: `${students_id.length} tutorando(s) atribuído(s) com sucesso!`,
        });

        this.studentsAssigneds = [];
        await this.getStudents();
        await this.getAssignedStudents();
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possível atribuir os tutorandos!",
          footer: "Por favor, tente novamente mais tarde.",
        });
      }
    },

    closeModal() {
      this.$root.$emit("bv::hide::modal", "tutoria");
    },
  },

  created() {
    this.getAssignedStudents();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

div#tutoria {
  .modal-dialog {
    max-width: 900px;

    .modal-content {
      background-color: $grey2;
      border: 0;
      border-radius: 0;

      .modal-body {
        padding: 60px;
      }
    }
  }

  h4.purple {
    color: $purple;
    font-weight: 700;
    margin-bottom: 30px;
  }

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .badge-count {
    color: $purple;
    font-weight: 600;
    font-size: 16px;
  }

  .wrap-competence {
    width: 100%;
    display: flex;
    flex-direction: column;
    // padding: 20px 0;

    .container-fluid {
      margin-left: -15px;
      margin-right: -15px;
    }

    .box-content {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 15px;
      row-gap: 15px;
      margin-right: -15px;
      margin-left: -15px;
      box-sizing: border-box;

      .col {
        .col-content {
          background: #fff;
          border: 1px solid #b3b3b3;
          border-radius: 10px;
          padding: 24px;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        &.list {
          .col-content {
            min-height: 300px;
          }
        }
      }
    }

    .students-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .about {
        margin-bottom: 15px;
        text-align: start;
        width: 100%;

        h5 {
          color: $grey3;
          font-weight: 600;
          margin: 0;
        }
      }

      form,
      fieldset {
        margin-bottom: 0;
        width: 100%;
      }

      ul {
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        max-height: 300px;
        margin: 0;
        padding: 0;
        overflow-x: hidden;
        overflow-y: auto;

        li {
          background-color: #f2f2f2;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 16px;
          list-style: none;
          transition: all 0.2s ease;

          &:hover {
            background-color: #e8e8e8;
          }

          &.clickable-student {
            cursor: pointer;

            &:hover {
              background-color: #d4f4dd;
              border-left: 4px solid $green2;
            }

            .add-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 28px;
              height: 28px;
              background-color: $green2;
              color: white;
              border-radius: 50%;
              font-size: 20px;
              font-weight: bold;
              transition: all 0.2s ease;
            }

            &:hover .add-icon {
              transform: scale(1.2);
            }
          }

          &.blocked-student {
            cursor: not-allowed;
            opacity: 0.7;

            &:hover {
              background-color: #ffe8e8;
              border-left: 4px solid #ff6b6b;
            }

            .blocked-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 28px;
              height: 28px;
              background-color: #ff6b6b;
              color: white;
              border-radius: 50%;
              font-size: 16px;
              transition: all 0.2s ease;
            }
          }

          &.current-student {
            border-left: 4px solid $blue;

            &:hover {
              background-color: #d4ebf3;
            }
          }

          .name {
            margin: 0;
            color: $grey3;
            font-weight: 500;
            font-size: 15px;
          }

          .remove-item {
            cursor: pointer;
            opacity: 0.6;
            transition: opacity 0.2s ease;

            &:hover {
              opacity: 1;
            }

            svg {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .empty-student-list {
      text-align: center;
      padding: 40px 20px;
      color: $grey4;
      font-style: italic;

      p {
        margin: 0;
      }
    }
  }

  .btn-remove-all-topics {
    background: $orange2;
    color: #fff;
    font-size: 13px;
    line-height: 20px;
    display: flex;

    width: 100%;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    padding: 10px 15px;
    border: none;
    transition: all 0.2s ease;

    &:hover {
      background: darken($orange2, 10%);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .btn-add-all-topics {
    background: $green2;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    // height: 36px;
    width: 100%;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    padding: 10px 20px;
    border: none;
    transition: all 0.2s ease;

    &:hover {
      background: darken($green2, 10%);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .box-select-all {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    justify-content: space-between;
    width: 100%;
    margin-top: 15px;

    select {
      padding: 10px 12px;
      border-radius: 6px;
      border: 1px solid $green2;
      background-color: $green2;
      color: $white;
      font-size: 14px;
      transition: all 0.2s ease;

      &:hover {
        background: darken($green2, 10%);
        transform: translateY(-2px);
      }

      &:focus {
        outline: none;
        border-color: $green2;
        box-shadow: 0 0 0 2px rgba($green2, 0.2);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .input-search {
    width: 100%;
    padding: 10px 12px;
    border-radius: 6px;
    border: 1px solid $grey3;
    background-color: #fff;
    color: $grey3;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: $green2;
      box-shadow: 0 0 0 2px rgba($green2, 0.2);
    }

    &:hover {
      border-color: $green1;
    }
  }

  .btn-remove-all-topics-small {
    background: $orange2;
    color: #fff;
    font-size: 13px;
    line-height: 20px;
    display: flex;

    width: 100%;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    padding: 10px 15px;
    border: none;
    transition: all 0.2s ease;

    &:hover {
      background: darken($orange2, 10%);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .student-container {
    border: 1px solid #b3b3b3;
    padding: 20px;
    margin-top: 20px;
    width: 96%;
    border-radius: 10px;
  }

  .title-current-students {
    width: 100%;
    text-align: start;
  }
}
</style>
